/**
 * Service layer — "Project Hold" (2026-08). A deliberate, visible pause on a project waiting on
 * the client — reuses Airtable's `Contract Stage = 'On Hold'` so the nightly scheduler, Billing
 * Run, and Progress Gate all skip it for free. See docs/PROJECT_HOLD.md. All calls go through the
 * Clerk-authed api/project-hold.js — no direct Supabase/Airtable access.
 *
 *   getProjectHoldStatus(projectId)                          → { hold } — hold is null if not held
 *   activateProjectHold(projectId, { reason, blockingMilestoneId, blockingMilestoneName })
 *   resumeProjectHold(projectId)
 */

async function authToken() { return window.__clerkGetToken ? await window.__clerkGetToken() : null }

async function holdPost(body) {
  const token = await authToken()
  const res = await fetch('/api/project-hold', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: 'Bearer ' + token } : {}) },
    body: JSON.stringify(body || {}),
  })
  let data = {}; try { data = await res.json() } catch { data = {} }
  if (!res.ok && !data.error) data.error = 'Request failed: ' + res.status
  return data
}
async function holdGet(qs) {
  const token = await authToken()
  const res = await fetch('/api/project-hold?' + qs, { headers: token ? { Authorization: 'Bearer ' + token } : {} })
  let data = {}; try { data = await res.json() } catch { data = {} }
  if (!res.ok && !data.error) data.error = 'Request failed: ' + res.status
  return data
}

export async function getProjectHoldStatus(projectId) {
  if (!projectId) return { hold: null }
  return holdGet('action=status&projectId=' + encodeURIComponent(projectId))
}
// Every active hold's project id — powers the project-list on-hold badge with one request
// instead of one per project.
export async function getActiveProjectHoldIds() {
  const d = await holdGet('action=activeHolds')
  return d.projectIds || []
}
export function activateProjectHold(projectId, { reason, blockingMilestoneId, blockingMilestoneName } = {}) {
  return holdPost({ action: 'activate', projectId, reason, blockingMilestoneId, blockingMilestoneName })
}
export function resumeProjectHold(projectId) {
  return holdPost({ action: 'resume', projectId })
}
